import { render, staticRenderFns } from "./WonderTopicDetail.vue?vue&type=template&id=507cbd45&scoped=true"
import script from "./WonderTopicDetail.vue?vue&type=script&lang=js"
export * from "./WonderTopicDetail.vue?vue&type=script&lang=js"
import style0 from "./WonderTopicDetail.vue?vue&type=style&index=0&id=507cbd45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507cbd45",
  null
  
)

export default component.exports